module.exports = __webpack_public_path__ + "img/header-topo.e8be6195.svg";